export default "__VITE_ASSET__mOUdtCQy__"